module.exports = __webpack_public_path__ + "static/media/s_18.6267df99.mp3";